module.exports = __webpack_public_path__ + "img/4.3606ab22.webp";